import {
    mariadb,
    sql,
    c,
    postgre,
    csharp,
    materialui,
    teamworking,
    ux,
    webdeveloping,
    problemsolving,
    wapa,
    lumina,
    TODO,
    piggypenny,
    pomo,
    ciakmov,
    briji,
    segno,
    circli,
    tortoisesvn,
    dbeaver,
    dayva,
    reactnative,
    expo,
    d3js,
    apacheECharts,
    chartjs,
    sfumix,
    reactreanimated, 
    svg,
    asyncstorage
    //tailwind,
    //netlify,
    //googlegeminiai
} from "../assets/icons";

const technologies = [
    {
        name: "React JS",
        icon: ['fab', 'react'],
    },
    {
        name: "JavaScript",
        icon: ['fab', 'js'],
    },
    {
        name: "Firebase",
        icon: ['fab', 'google'],
    },
    {
        name: "Chart.js",
        icon: chartjs,
    },
    {
        name: "D3.js",
        icon: d3js,
    },
    {
        name: "Apache ECharts",
        icon: apacheECharts,
    },
    {
        name: "React Native",
        icon: reactnative,
    },
    {
        name: "Expo",
        icon: expo,
    },
    {
        name: "Python",
        icon: ['fab', 'python'],
    },
    {
        name: "DBeaver",
        icon: dbeaver,
    },
    {
        name: "TortoiseSVN",
        icon: tortoisesvn,
    },
    {
        name: "Material UI",
        icon: materialui,
    },
    {
        name: "HTML 5",
        icon: ['fab', 'html5'],
    },
    {
        name: "CSS 3",
        icon: ['fab', 'css3-alt'],
    },
    {
        name: "SQL",
        icon: sql,
    },
    {
        name: "Maria DB",
        icon: mariadb,
    },
    {
        name: "PostgreSQL",
        icon: postgre,
    },
    {
        name: "PHP",
        icon: ['fab', 'php'],
    },
    {
        name: "C / C++",
        icon: c,
    },
    {
        name: "Figma",
        icon: ['fab', 'figma'],
    },
    {
        name: "C#",
        icon: csharp,
    },
    {
        name: "Coding",
        icon: webdeveloping,
    },
    {
        name: "UX Design",
        icon: ux,
    },
    {
        name: "Team working",
        icon: teamworking,
    },
    {
        name: "Problem solving",
        icon: problemsolving,
    },
];

const experiences = [
    {
        title: "Junior Software Engineer - IT Consultant",
        company_name: "aizOon Technology Consulting / Hitachi Rail, Genoa (IT)",
        date: "July 2025 - Present",
        points: [
            "Software Development & UI Design: Developed a demonstrative software for remote train control, designing and implementing modular React interfaces with a strong focus on usability, responsiveness, and User Experience (UX).",
            "Front-end Architecture: Engineered reusable and scalable components using ReactJS and TypeScript/JavaScript, leveraging custom hooks (useState, useEffect, useContext) to manage complex component logic and state.",
            "Systems Integration: Managed communication between the front-end and external services by consuming REST APIs (GET), including the integration of real-time environmental data like OpenWeatherMap.",
            "Full-stack Ecosystem: Contributed to both front-end and back-end logic, utilizing a diverse tech stack including JavaScript, Python, and C.",
            "DevOps & Testing Tools: Streamlined the development workflow using TortoiseSVN for version control and managed testing environments by deploying C code on Ubuntu virtual machines via Oracle VirtualBox."
        ]
    },
    {
        title: "Full Stack Developer - IT Consultant",
        company_name: "ALTEN Italia",
        date: "April 2024 - Present",
        points: [
            "Developed web apps using React.js.",
            "Created a meteorological web app (university thesis) with API integration and Firebase.",
            "Utilized Scrum for efficient project delivery.",
            "Enhanced skills in JavaScript, React.js, PHP, and SQL.",
            "Focused on robust, scalable, and user-centric web applications."
        ],
    },
];

const projects = [
     {
        name: "SFUMIX",
        demoLink: "https://apps.apple.com/it/app/sfumix/id6775259800sfumix",
        logo: sfumix,
        info: "Sfumix - Generator of gradient wallpapers",
        description:
            "Sfumix is a native mobile application dedicated to the generation and cataloging of abstract minimalist wallpapers. The app allows users to create unique linear and radial gradients in real time. Now is available in the App store",
        tags: [
            {
                name: "React Native",
                icon: reactnative,
            },
            {
                name: "Expo",
                icon: expo,
            },
            {
                name: "JavaScript",
            },
            {
                name: "React Reanimated",
                icon: reactreanimated,
            },
            {
                name: "AsyncStorage",
                icon: asyncstorage,
            },
            {
                name: "SVG",
                icon: svg,
            }
        ],
       features: [
        "🎨 Dual-Mode Generation: Mathematical generation of random colors in hexadecimal format with support for Linear and Radial (SVG) gradients.",
        "🔮 Dynamic Island UI: A single smart floating pill that dynamically manages both the display of active color codes and system notification banners.",
        "💎 Glassmorphic Navigation: Floating and centered Tab Bar featuring a frosted-glass effect, real-time background blur, and reflective micro-borders.",
        "📱 Native Device Sync: High-resolution export system via ViewShot with complete hardware synchronization. Deleting from the app removes the file directly from the device's photo gallery (iOS/Android) using asynchronous permission requests.",
        "🔄 Local History Management: Archiving and persistence of favorite gradients through AsyncStorage for immediate offline consultation and regeneration.",
        "✨ Fluid Onboarding: Immersive welcome screen featuring a procedural pulsing animation at 60 FPS delegated entirely to the native UI thread."
    ],
        start: "05/2026",
        end: "",
        source_code_link: "",
    },
    {
        name: "LUMINA",
        demoLink: "https://luminaappshooting.netlify.app/",
        logo: lumina,
        info: "AI-Powered Weather & Photography Assistant",
        description:
            "Lumina is an innovative application designed for photographers and travelers who want to capture the perfect shot. The app analyzes real-time weather data and geographical location to provide personalized technical recommendations (ISO, Aperture, Shutter Speed) through Google Gemini AI. Featuring an ultra-modern and dynamic interface, Lumina turns any weather condition into a creative opportunity.",
        tags: [
            {
                name: "React",
            },
            {
                name: "Tailwind",
            },
            {
                name: "Google Gemini AI",
            },
            {
                name: "Netlify",
            },
            {
                name: "TypeScript",
            },
        ],
        features: [
            "📸 AI Photography Advice: Technical settings based on real-time weather and lighting",
            "🌤️ Dynamic Weather Engine: Real-time integration with OpenWeather API",
            "⏳ Light Timeline: Automatic tracking of Golden Hour, Blue Hour, and Solar Noon",
            "⚡ Serverless Architecture: Secure AI API management via Netlify Functions",
        ],
        start: "",
        end: "",
        source_code_link: "https://luminaappshooting.netlify.app/",
    },
    {
        name: "DAYVA",
        demoLink: "",
        logo: dayva,
        info: "Daily Life & Task Organizer App",
        description:
            "Introducing DAYVA: your personal daily life manager! I developed this mobile-first app to help people organize tasks, time, and priorities in a simple but powerful way. With DAYVA you can plan your day, manage tasks with reminders, visualize your productivity through insights and charts, and stay focused on what really matters. The app features a clean, minimal UI inspired by modern mobile design and supports dark/light mode, offline usage and sync. DAYVA is designed to feel like a natural extension of your daily routine.",
        tags: [
            {
                name: "React Native",
            },
            {
                name: "Expo",
            },
            {
                name: "Zustand",
            },
            {
                name: "TypeScript",
            },
            {
                name: "Firebase",
            },
        ],
        features: [
            "🗓️ Daily agenda with smart task organization",
            "📊 Weekly insights with productivity charts",
            "🌙 Automatic dark / light mode",
            "📴 Offline-first with background sync",
            "📅 Calendar view with daily task breakdown",
        ],
        start: "📅 12/2025",
        end: "📅 In progress",
    },
    {
        name: "WAPA",
        demoLink: "https://wapaweather.com/",
        logo: wapa,
        info: "Weather and Advanced Predictions App",
        description:
            "Introducing WAPA: the Weather and Advanced Predictions App! I developed this web app with React as my university thesis project. With WAPA, you can get detailed weather information for the locations you care about, either via GPS or by searching manually. WAPA is a Progressive Web App (PWA), so you can install it directly from your browser for faster access! ⚠️ Responsive design is still being improved, so it may not be perfect on all devices. The app uses weather and astronomical APIs to collect data and charting libraries for clear and interactive representation. Weather and the universe, at your fingertips!",
        tags: [
            {
                name: "React",
            },
            {
                name: "Firebase",
            },
            {
                name: "HTML",
            },
            {
                name: "JavaScript",
            },
            {
                name: "CSS",
            },
        ],
        features: [
            "🌤️ Real-time weather data, with temperature graph",
            "⏳ Up to 5-day forecasts, updated every 3 hours",
            "📊 Advanced graphs on wind speed, atmospheric pressure, dew point, and air quality",
            "💬 User accounts to save up to 6 favorite locations",
            "🌙 Lunar phases and celestial events",
            "🌍 Natural events, categorized",
            "🪐 Near-Earth object monitoring",
            "☀️ Solar activity and solar flares",
        ],
        start: "📅 04/2024",
        end: "📅 10/2024",
        source_code_link: "https://wapaweather.com/",
    },
    {
        name: "Circli",
        demoLink: "https://circli.netlify.app/",
        logo: circli,
        info: "🔄📱 Mini social network for sharing thoughts and moments",
        description: "I'm building this React-based social network where users can share posts, like, and comment, creating a dynamic and interactive community.",
        tags: [
            { name: "React" },
            { name: "Firebase" },
            { name: "Auth0" },
            { name: "Material UI" },
            { name: "JavaScript" },
            { name: "HTML" },
            { name: "CSS" }
        ],
        features: [
            "🔐 Secure authentication with Firebase/Auth0",
            "📝 Share messages and images with the community",
            "❤️ Like and comment on posts in real time",
            "👤 Personalized user profile with stored data",
            "📱 Mobile-friendly and responsive design",
            "🚀⚠️ The project is still under development!"
        ],
        technologies: [
            "⚛️ React",
            "🔥 Firebase/Auth0",
            "🎨 Material UI",
            "💻 HTML, CSS, JavaScript"
        ],
        source_code_link: "https://circli.netlify.app/SignIn"
    },
    {
        name: "PiggyPenny",
        demoLink: "https://piggypennyapp.com//",
        logo: piggypenny,
        info: "🐷🚀 Finance app to manage your wallet",
        description: "I've developed this React web app to help you track your income and expenses in a simple and intuitive way.",
        tags: [
            { name: "React" },
            { name: "HTML" },
            { name: "JavaScript" },
            { name: "CSS" },
            { name: "ReactApexChart" },
            { name: "Firebase" },
            { name: "Material UI" }
        ],
        features: [
            "🔐 Google Sign-in for secure wallet management",
            "📋 Add expenses and income through an easy-to-use form",
            "🔍 Filter transactions based on your preferred period",
            "📑 View a complete list of your expenses in a clear and organized way",
            "📊 Analyze your financial data with interactive charts",
            "📱 Progressive Web App (PWA) – install it directly from your browser!"
        ],
        technologies: [
            "⚛️ React",
            "🎨 Material UI",
            "📊 ReactApexChart",
            "🔥 Firebase",
            "💻 HTML, CSS, JavaScript"
        ],
        source_code_link: "https://piggypennyapp.com/"
    },
    {
        name: "Segno",
        logo: segno,
        info: "📝📂 A simple web app for managing your notes",
        description: "I've developed this PHP-based web application to help you create, organize, and manage your notes efficiently. Currently, it is not hosted.",
        tags: [
            { name: "PHP" },
            { name: "HTML" },
            { name: "CSS" },
            { name: "MySQL" },
            { name: "phpMyAdmin" }
        ],
        features: [
            "🔐 User authentication for secure note management",
            "📝 Add notes with categories and tags for better organization",
            "❌ Delete notes when no longer needed",
            "📖 View and read all your saved notes easily"
        ],
        technologies: [
            "🐘 PHP",
            "🗄️ MySQL",
            "🌐 HTML, CSS",
            "🛠️ phpMyAdmin"
        ],
        source_code_link: "https://github.com/simlu2000/segno"
    },
    {
        name: "YouTodo",
        demoLink: "https://piggypennyapp.com/",
        logo: TODO,
        info: "📝🚀 ToDoList app to boost your productivity",
        description: "I've developed this React web app to help you organize your daily tasks and track your productivity with interactive charts.",
        tags: [
            { name: "React" },
            { name: "HTML" },
            { name: "JavaScript" },
            { name: "CSS" },
            { name: "React Calendar" },
            { name: "ReCharts" },
            { name: "Firebase" },
            { name: "Material UI" }
        ],
        features: [
            "📝 Add new tasks through an intuitive form",
            "📅 View your tasks day by day, also in the calendar",
            "📊 Monitor your productivity with pie and line charts",
            "🌙☀️ Light / Dark mode based on your preference",
            "📱 Progressive Web App (PWA) – install it directly from your browser!"
        ],
        technologies: [
            "⚛️ React",
            "📅 React Calendar",
            "📊 ReCharts",
            "🎨 Material UI",
            "🔥 Firebase",
            "💻 HTML, CSS, JavaScript"
        ],
        source_code_link: "https://youtodoapp.netlify.app/"
    },
    {
        name: "Pomo",
        demoLink: "https://focuspomoapp.netlify.app/",
        logo: pomo,
        info: "🍅⏳ Pomodoro timer app to boost your focus",
        description: "I've developed Pomo, a React app based on the Pomodoro technique, to help you stay focused and visualize your progress in a unique way! 🎯",
        tags: [
            { name: "React" },
            { name: "HTML" },
            { name: "JavaScript" },
            { name: "CSS" },
            { name: "Material UI" }
        ],
        features: [
            "👤 Sign in easily with just your name",
            "⏳ Use a 25-minute Pomodoro timer to maximize focus",
            "📈 Track your productivity with a line chart showing your tomato growth day by day",
            "📱 Progressive Web App (PWA) – install it directly from your browser for quick access!"
        ],
        technologies: [
            "⚛️ React",
            "🎨 Material UI",
            "💻 HTML, CSS, JavaScript"
        ],
        source_code_link: "https://focuspomoapp.netlify.app/"
    },
    {
        name: "Briji",
        logo: briji,
        info: "🧑‍💼💼 Recruitment Platform for companies and workers",
        description:
            "Briji is a recruitment platform developed for a Web Design course by a team of 20 members, including both developers and designers. The project aims to simplify job searching for candidates and talent acquisition for companies. 🔎🏢 Data storage is managed using AirTable, and the platform is optimized for 1920x1080px resolution. The backend for login and registration was not implemented, but some components use Material Design 2.",
        tags: [
            { name: "🗄️ AirTable" },
            { name: "💻 HTML" },
            { name: "📜 JavaScript" },
            { name: "🎨 CSS" }
        ],
        features: [
            "🖨️ Print user data",
            "✏️ Modify user data",
            "🏢 View a company profile associated with a job post",
            "📑 Edit job listing details"
        ],
        source_code_link: "https://gruppo5webd.altervista.org/progetto_finale/home/homepage.html",
        start: "📅 04/2023",
        end: "📅 07/2023"
    },
    {
        name: "Ciakmov",
        logo: ciakmov,
        info: "🎬🍿 Website to search film in Genoa",
        description:
            "Ciakmov is a website developed for the Web Application Development course (academic year 2021/2022), allowing users to search for movies showing in Genoa's cinemas and post reviews. 🏙️🎞️ Registered users can also subscribe to a weekly newsletter managed by administrators via a dedicated admin panel.",
        tags: [
            { name: "🐘 PostgreSQL" },
            { name: "🛢️ SQL" },
            { name: "🐬 MariaDB" },
            { name: "💻 PHP" },
            { name: "🖥️ HTML" },
            { name: "📜 JavaScript" },
            { name: "🎨 CSS" }
        ],
        features: [
            "🔐 Login and Sign Up",
            "📩 Newsletter (PHPMailer)",
            "⭐ Movie Ratings (score)",
            "⚙️ Administrative Area"
        ],
        source_code_link: "https://github.com/simlu2000/SAW",
        start: "📅 02/2022",
        end: "📅 08/2022"
    }
];

const education = [
    {
        year: "10/2019 - 19/02/2026",
        school: "University of Genoa, Italy",
        course: "BSc in Computer Science"
    },
    {
        year: "2014 - 2019",
        school: "Istituto F. Liceti, Rapallo (Italy)",
        course: "Corporate Information Systems"
    },
];

export { technologies, experiences, projects, education };